import axios from "axios";
import ApiError from "./api-error";
import {forceLogout} from "./utils/sessionUtils";

// Guard so a burst of concurrent requests all 401-ing only triggers one logout
// + redirect (otherwise each failed call would stomp the location/storage).
let handlingUnauthorized = false;

// export default instance
let Axios = axios.create({
    // withCredentials: false,
    crossDomain: true,
    crossOrigin: true,
});

Axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token") || null;
    config.headers.Authorization = token ? `Bearer ` + token : null;
    return config;
});

Axios.interceptors.response.use(
    (response) => {
        // TO STORE THE JWT TOKEN FROM RESPONSE
        return response;
    },
    (error) => {
        console.error("API Error:", error); // Log the error for easier debugging

        // Global 401 handling: an authenticated session that comes back
        // UNAUTHORIZED (expired token, or a server-side block such as
        // SCHOOL_BLOCKED) is force-logged-out and bounced to the login screen,
        // surfacing the backend errorMessage there. Only fires when a token was
        // present, so a failed login attempt (no session yet) isn't hijacked.
        const status = error.response ? error.response.status : null;
        const hadToken = !!localStorage.getItem("token");
        if (status === 401 && hadToken && !handlingUnauthorized) {
            handlingUnauthorized = true;
            const data = error.response && error.response.data;
            forceLogout((data && data.errorMessage) || "");
        }

        return ApiError.errorHandler(error);
    }
);

export default Axios;
